import React, { FunctionComponent } from "react";
import { Demo } from "../components/demo";
import { ComponentProps } from "../components/component-props";

import "./text-field-demo.scss";

// Filled text field

const textFieldDemo = {
    code:
`const TextFieldDemo = () => {
    const [value, setValue] = React.useState("");
    return (
        <TextField
            label="Foo"
            value={value}
            onChange={e => setValue(e.currentTarget.value)} />
    );
};

render(<TextFieldDemo />);`,
    noInline: true
};

export const TextFieldDemo: FunctionComponent = () => {
    return (
        <Demo demo={textFieldDemo}>
            <ComponentProps componentName="TextField" />
        </Demo>
    );
};


// Filled text field - text area

const textFieldFilledTextAreaDemo = {
    code:
`const TextFieldFilledTextAreaDemo = () => {
    const [value, setValue] = React.useState("");
    return (
        <TextField
            label="Foo"
            textarea
            value={value}
            onChange={e => setValue(e.currentTarget.value)} />
    );
};

render(<TextFieldFilledTextAreaDemo />);`,
    noInline: true
};

export const TextFieldFilledTextAreaDemo: FunctionComponent = () => {
    return (
        <Demo demo={textFieldFilledTextAreaDemo}>
            <ComponentProps componentName="TextField" />
        </Demo>
    );
};


// Outlined text field

const textFieldOutlineDemo = {
    code:
`const TextFieldOutlineDemo = () => {
    const [value, setValue] = React.useState("");
    return (
        <TextField
            label="Foo"
            outlined
            value={value}
            onChange={e => setValue(e.currentTarget.value)} />
    );
};

render(<TextFieldOutlineDemo />);`,
    noInline: true
};

export const TextFieldOutlineDemo: FunctionComponent = () => {
    return (
        <Demo demo={textFieldOutlineDemo}>
            <ComponentProps componentName="TextField" />
        </Demo>
    );
};


// Outlined text field - text area

const textFieldOutlinedTextAreaDemo = {
    code:
`const TextFieldOutlinedTextAreaDemo = () => {
    const [value, setValue] = React.useState("");
    return (
        <TextField
            label="Foo"
            textarea
            outlined
            value={value}
            onChange={e => setValue(e.currentTarget.value)} />
    );
};

render(<TextFieldOutlinedTextAreaDemo />);`,
    noInline: true
};

export const TextFieldOutlinedTextAreaDemo: FunctionComponent = () => {
    return (
        <Demo demo={textFieldOutlinedTextAreaDemo}>
            <ComponentProps componentName="TextField" />
        </Demo>
    );
};
